import { cn } from '@shared/lib/cn';

import { SIZE_CLASS, type TextInputSize } from './text-input.constant';

export interface TextInputSkeletonProps {
  size?: TextInputSize;
  /** 너비는 부르는 쪽이 준다(기본은 부모 너비) */
  className?: string;
}

/** TextInput 의 status=init — 입력 상자 크기의 면 */
export function TextInputSkeleton({ size = 'md', className }: TextInputSkeletonProps) {
  return (
    <div
      aria-hidden="true"
      data-status="init"
      className={cn(
        'skeleton-pulse',
        'w-full rounded-md bg-bg-pressed',
        SIZE_CLASS[size],
        className,
      )}
    />
  );
}
